export enum GEOMETRY_TYPE {
  POINT = 'point',
  POLYGON = 'polygon',
  POLYLINE = 'polyline'
}

export enum SYMBOL_TYPE {
  MARKER = 'simple-marker',
  LINE = 'simple-line',
  FILL = 'simple-fill'
}

export interface EsriSymbol {
  type: SYMBOL_TYPE;
  color: number[] | string;
  outline?: {
    width: number;
    color: number[] | string;
  };
}

export enum SR_WKID {
  WEB_MERCATOR = 3857
}
